document.addEventListener('DOMContentLoaded', function () {
    const drawer = document.querySelector('.collection__sidebar__slider');
    const openButton = document.querySelector('.collection__sidebar__open'); // button to show filters
    const closeButton = document.querySelector('.collection__sidebar__close');
    const filterGroups = document.querySelectorAll('.filter-group');
    const DESKTOP_BREAKPOINT = 1024; // adjust if needed

    // ===== Reset classes on page load =====
    function initializeDrawerState() {
        if (window.innerWidth >= DESKTOP_BREAKPOINT) {
            // Desktop: always visible, no drawer behavior
            drawer.classList.add('expanded');
            drawer.classList.remove('drawer--animated', 'no-mobile-animation');
        } else {
            // Mobile: start closed
            drawer.classList.remove('expanded', 'drawer--animated', 'no-mobile-animation');
        }
    }

    // ===== OPEN drawer (mobile only) =====
    function openDrawer() {
        if (window.innerWidth < DESKTOP_BREAKPOINT) {
            drawer.classList.add('expanded', 'drawer--animated', 'no-mobile-animation');
        }
    }

    // ===== CLOSE drawer (mobile only) =====
    function closeDrawer() {
        if (window.innerWidth < DESKTOP_BREAKPOINT) {
            drawer.classList.remove('expanded', 'drawer--animated', 'no-mobile-animation');
        }
    }

    // ===== Prevent filter clicks from closing drawer (desktop only) =====
    function preventFilterCollapse(event) {
        if (window.innerWidth >= DESKTOP_BREAKPOINT && event.target.closest('.filter-group')) {
            event.stopPropagation();
        }
    }

    // Init state
    initializeDrawerState();

    // Re-initialize when resizing (so switching desktop <-> mobile works)
    window.addEventListener('resize', initializeDrawerState);

    // Listeners
    if (openButton) openButton.addEventListener('click', openDrawer);
    document.addEventListener('click', function (e) {
    if (e.target.closest('.collection__sidebar__close')) {
        e.stopPropagation();
        closeDrawer();
    }
    });

    // Prevent sidebar closing on filter clicks (desktop only)
    filterGroups.forEach(filterGroup => {
        filterGroup.addEventListener('click', preventFilterCollapse);
    });
});
